import React, { useState, useCallback, forwardRef } from 'react';
import { StyledDragCard } from './styled';
export const DragCard = forwardRef(function DragCard({ onDragStart, onDragEnd, children, ...props }, ref) {
    const [dragging, setDragging] = useState(false);
    const handleDragStart = useCallback((e) => {
        // onDragStart attribute is required for Firefox for a dragging initialization
        // @see https://bugzilla.mozilla.org/show_bug.cgi?id=568313
        e.dataTransfer.setData('text/plain', '');
        if (onDragStart)
            onDragStart(e);
        setDragging(true);
    }, [onDragStart]);
    const handleDragEnd = useCallback((e) => {
        if (onDragEnd)
            onDragEnd(e);
        setDragging(false);
    }, [onDragEnd]);
    return (React.createElement(StyledDragCard, { draggable: true, ref: ref, dragging: dragging, onDragStart: handleDragStart, onDragEnd: handleDragEnd, ...props }, children));
});
